import React from 'react';
import { Phone, Mail } from 'lucide-react';
import LeadCaptureForm from './LeadCaptureForm';

const CTASection = () => {
  return (
    <section id="quote" className="py-20 px-4 bg-gradient-to-b from-white to-slate-50 scroll-mt-20">
      <div className="container mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Ready for a Spotless, Organized Garage?
            </h2>
            <p className="text-xl text-slate-600 mb-8 leading-relaxed">
              Request your free quote today and discover why Winter Park homeowners trust One Clean Garage for all their garage organization needs.
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-4 p-4 bg-white rounded-lg border border-slate-200">
                <div className="bg-emerald-100 p-3 rounded-full">
                  <Phone className="h-6 w-6 text-emerald-600" />
                </div>
                <div>
                  <p className="text-sm text-slate-600">Call us directly</p>
                  <a href="tel:386-283-0286" className="text-2xl font-bold text-slate-900 hover:text-emerald-600">
                    386-283-0286
                  </a>
                </div>
              </div>
              
              <div className="flex items-center gap-4 p-4 bg-white rounded-lg border border-slate-200">
                <div className="bg-emerald-100 p-3 rounded-full">
                  <Mail className="h-6 w-6 text-emerald-600" />
                </div>
                <div>
                  <p className="text-sm text-slate-600">Email us</p>
                  <a href="mailto:lexi@onecleangarage.com" className="text-lg font-semibold text-slate-900 hover:text-emerald-600">
                    lexi@onecleangarage.com
                  </a>
                </div>
              </div>
            </div>
            
            <div className="bg-emerald-50 p-6 rounded-lg border border-emerald-200">
              <p className="text-sm text-emerald-900 font-medium mb-2">📍 Service Area</p>
              <p className="text-emerald-800">
                Proudly serving Winter Park, Orlando, Maitland, Altamonte Springs & the Greater Orlando Area
              </p>
            </div>
          </div>
          
          <div>
            <LeadCaptureForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;